<script setup lang="ts">
import { useData } from 'vike-vue/useData'
import type { SimulatorPageData } from '@/pages/(subscription)/+data'

const { footer } = useData<SimulatorPageData>()

const footerContent = {
  links: footer?.secondaryMenu,
}
</script>

<template>
  <organisms-ui-footerLite
    id="footer-lite"
    :links="footerContent.links ?? []"
    class="Footer Footer-lite"
  />
</template>

<style lang="scss">
@use 'utilities/mq';

.Footer-lite {
  margin-bottom: calc(4.8rem + calc(2 * 1.2rem));

  @include mq.media('>=small') {
    margin-bottom: calc(4.8rem + calc(2 * 1.6rem));
  }
}
</style>
